<template>
  <div
    :class="[
      $style.container,
      !currentInSlider ? $style.containerSmall : ''
    ]">
    <GiantTitle
      data-anim="title"
      data-anim-enter="title"
      :title="content.title"
      :color="'light'"
      v-if="!getStateSlider"
    />
    <GradientText :content="content.payoff" />

    <svg v-if="$route.name !== 'contact-us'" data-anim="top" :class="$style.arrow" ref="icon"><use xlink:href="#arrow"/></svg>
    <div :class="$style.spacer" v-else></div>

    <div
      v-if="content.image !== undefined && $store.state.route.name !== 'fitness' && $store.state.route.name !== 'experience'"
      :class="$style.parallax"
      :style="{
        backgroundImage: `url(${content.image})`,
      }"
      data-anim="parallax"
      data-anim-enter="image"
      ></div>

      <div
        :class="$style.parallax"
        data-anim-enter="image"
        v-if="$store.state.route.name === 'fitness' || $store.state.route.name === 'experience'"
      >
        <div
          v-for="(image, i) in content.images"
          data-anim="parallax"
          :data-parallax="`${(i - 1.5) / 20}`"
          :key="i"
          :style="{ backgroundImage: `url(${image})` }"
        >
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import GiantTitle from '@/components/GiantTitle'
import GradientText from '@/components/GradientText'

export default {
  name: 'intro',

  components: {
    GradientText,
    GiantTitle
  },

  props: ['content'],

  computed: {
    ...mapGetters(['getStateSlider']),
    ...mapGetters(['currentInSlider'])
  }
}
</script>

<style module lang="scss">
@import "~sass-mq/mq";

.container {
  @include grid-size();

  position: relative;
  display: flex;
  flex-flow: column;
  justify-content: space-around;

  padding: 0 $big-margin-mobile;

  @include mq(sm) {
    padding: 0 $big-margin;
    padding-right: 0;
    height: 60vh;
    height: calc(var(--vh, 1vh) * 60);
  }

  @include mq(md) {
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);

    &.containerSmall {
      height: auto;
    }
  }
}

.arrow {
  width: 20px;
  height: 50px;
  display: none;
}

.spacer {
  height: 80px;
}

.parallax {
  position: relative;
  top: 15%;
  width: 60%;
  height: 80%;

  z-index: -1;

  & div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-size: auto 80%;
    background-position: center center;
    background-repeat: no-repeat;
  }

  background-size: auto 80%;
  background-position: center center;
  background-repeat: no-repeat;

  @include mq(sm) {
    position: absolute;
    right: 0;
    bottom: -10%;

    width: 50%;
    height: 90%;
  }

  @include mq(ds) {
    width: 60%;
    height: 80%;
  }

  @include mq(lg) {
    width: 75%;
    right: -15%;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/IntroBlock.vue